import { api } from '@/api';

export interface PostEventMessageCopiedRequest {
  messageId: string;
}

const eventMessageCopiedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postEventMessageCopied: builder.mutation<void, PostEventMessageCopiedRequest>({
      query: ({ messageId }) => ({
        url: '/event/message/copied',
        method: 'POST',
        body: { messageId },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostEventMessageCopiedMutation } = eventMessageCopiedApi;
